export default class PackageDetailsIdKey {
  packageModelId?: string;
}
